import { useEffect, useState } from "react";
import { ReportsChart, StatisticCard, StatisticTable } from "./ReportsViews";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaMoneyBill, FaUserLock } from "react-icons/fa";
import { TbArrowsUpDown } from "react-icons/tb";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import axios from "axios";
import _ from "lodash";
import BrokerageView from "./BrokerageView";
import Modal from "react-bootstrap/Modal";
import filterFactory, {
  textFilter,
  numberFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

const AdminView = (props) => {
  const brokerage = props.brokerage;
  const [brokerageReportData, setBrokerageReportData] = useState({});
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState("brokers");
  const [tableInfo, setTableInfo] = useState([]);
  const [chartData, setChartData] = useState();
  const [view, setView] = useState("main");
  const [selectedItem, setSelectedItem] = useState();
  const [prospectsCharts, setProspectsCharts] = useState();
  const [prospectStatusCharts, setProspectStatusCharts] = useState();
  const [transactionCharts, setTransactionCharts] = useState();
  const [prospectModal, setProspectModal] = useState(false);
  const [bindChart, setBindChart] = useState();
  const [datePickerStart, setDatePickerStart] = useState(new Date());
  const [datePickerEnd, setDatePickerEnd] = useState(new Date());
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedBroker, setSelectedBroker] = useState("");
  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const filterDataByDateRange = (data, start, end, path: "createdAt") => {
    if (!start || !end) return data;
    return data.filter((item) => {
      const itemDate = new Date(_.get(item, path));
      return itemDate >= start && itemDate <= end;
    });
  };

  const filterData = (data, matchingItem, path = "status") => {
    if (!matchingItem) return data;
    return data.filter((item) => {
      return _.get(item, path) === matchingItem;
    });
  };

  const getDropdownItems = (data, path = "transactions[0].tostatus") => {
    // Extract statuses
    const statuses = data.map((item) => _.get(item, path));

    // Filter out unique statuses
    const uniqueStatuses = [...new Set(statuses)];

    // Format for react-select
    const formattedStatuses = uniqueStatuses.map((status) => ({
      value: status,
      label: status,
    }));

    return formattedStatuses;
  };

  const handleClick = (data) => {
    setSelectedItem(data);
    if (data.view) {
      changeView(data.view);
    }
  };

  const changeView = (viewName) => {
    setView(viewName);
  };

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASICSERVICE + "/api/brokerages/getAdminReport"
      )
      .then((response) => {
        var tempReportData = response.data;

        tempReportData["brokers"] = joinData(
          tempReportData.brokers,
          tempReportData.transactions,
          "transactions",
          "_id",
          "userid"
        );

        tempReportData["prospects"] = joinData(
          tempReportData.prospects,
          tempReportData.transactions,
          "transactions",
          "_id",
          "prospectid"
        );

        tempReportData["prospects"] = joinData(
          tempReportData.prospects,
          tempReportData.brokers,
          "broker",
          "userid",
          "_id"
        );

        tempReportData["prospects"] = joinData(
          tempReportData.prospects,
          tempReportData.binders,
          "binders",
          "_id",
          "prospectid"
        );

        tempReportData["brokerage"] = joinData(
          tempReportData.brokerage,
          tempReportData.prospects,
          "prospects",
          "code",
          "brokeragecode"
        );

        console.log(
          "living a life beyond",
          tempReportData.brokers.filter((d) => {
            return "60ccf3a33e7e9b7ab0392f3d" === d._id;
          })
        );
        setBrokerageReportData(tempReportData);
        const tempCard = [
          {
            icon: FaBuilding,
            title: "Dashboard",
            // data: tempReportData.brokerage.length,
            view: "dashboard",
          },
          {
            icon: FaBuilding,
            title: "Brokerages",
            data: tempReportData.brokerage.length,
            view: "brokerage",
          },
          {
            icon: FaUser,
            title: "Brokers",
            data: tempReportData.brokers.length,
            view: "brokers",
          },
          {
            icon: TbArrowsUpDown,
            title: "Transactions",
            data: tempReportData.transactions.length,
            view: "transactions",
          },
          {
            icon: FaUserFriends,
            title: " Prospects",
            data: tempReportData.prospects.length,
            view: "prospects",
          },
          //   {
          //     icon: FaMoneyBill,
          //     title: "Total Revenue",
          //     data: _.sumBy(tempReportData.payments, "total_amount"),
          //     view: "payment",
          //   },
          {
            icon: FaUserLock,
            title: "Binders",
            data: tempReportData.binders.length,
            view: "binders",
          },
        ];

        setCards(tempCard);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const prepareChartData = (data, groupKeyGetter, statusField) => {
    // Sort data by group key
    const sortedData = _.sortBy(data, groupKeyGetter);

    // Group data by group key
    const groupedData = _.groupBy(sortedData, groupKeyGetter);

    // Create labels array (unique group keys)
    const labels = Object.keys(groupedData);

    // Create datasets array
    const datasets = [];
    for (let groupKey of labels) {
      const counts = _.countBy(groupedData[groupKey], statusField);
      for (let status of Object.keys(counts)) {
        // Ignore insurers with 0 count
        if (counts[status] === 0) {
          continue;
        }

        let dataset = datasets.find((d) => d.label === status);
        if (!dataset) {
          dataset = {
            label: status,
            data: new Array(labels.length).fill(0), // initialize data array with zeros
          };
          datasets.push(dataset);
        }
        dataset.data[labels.indexOf(groupKey)] = counts[status];
      }
    }

    return { labels, datasets };
  };

  const prepareChartDataForOneField = (data, groupKeyGetter) => {
    // Sort data by group key
    const sortedData = _.sortBy(data, groupKeyGetter);

    // Group data by group key
    const groupedData = _.groupBy(sortedData, groupKeyGetter);

    // Create labels array (unique group keys)
    const labels = Object.keys(groupedData);

    // Create a single dataset containing count per group key
    const dataset = {
      label: "Prospects Created",
      data: labels.map((key) => groupedData[key].length),
      backgroundColor: "blue", // set a fixed color or generate a random color here
    };

    return { labels, datasets: [dataset] };
  };

  function preparePieChartData(list, keyGetter) {
    // Group data by key
    const groupedData = _.groupBy(list, keyGetter);

    // Create labels array (unique keys)
    const labels = Object.keys(groupedData);

    // Create data array (counts of each key)
    const data = labels.map((label) => groupedData[label].length);

    // Create color array (random colors for each key)
    const backgroundColors = labels.map(
      () => "#" + Math.floor(Math.random() * 16777215).toString(16)
    );

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColors,
        },
      ],
    };
  }

  function prepareInsurerCounts(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return names.map((name) => ({
      name,
      amount: counts[name],
    }));
  }

  function prepareInsurerCountsForChart(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return {
      labels: names,
      datasets: [
        {
          label: "Insurer Count",
          data: names.map((name) => counts[name]),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
    };
  }

  function countLabelsAndBindings(list, labelGetter, isBindedGetter) {
    const groupedData = _.groupBy(list, labelGetter);
    const labels = Object.keys(groupedData);

    return labels.map((label) => {
      const itemsWithLabel = groupedData[label];
      const totalCount = itemsWithLabel.length;
      const bindCount = itemsWithLabel.filter(isBindedGetter).length;

      return {
        vertical: label,
        count: totalCount,
        bindCount,
      };
    });
  }

  const groupKeyGetter = (item, path) => _.get(item, path);

  useEffect(() => {
    const groupKeyGetterProspects = (item) =>
      _.get(item, "answers.operations.list[0].vertical.name.en");

    const groupKeyGetterTransactions = (item) => {
      const date = new Date(item.usertime);
      return date.toLocaleDateString(); // Convert to a string in the format 'MM/DD/YYYY'
    };

    setProspectsCharts(
      preparePieChartData(
        brokerageReportData.prospects,
        groupKeyGetterProspects
      )
    );

    setChartData(
      prepareChartData(
        brokerageReportData.transactions,
        groupKeyGetterTransactions,
        "tostatus"
      )
    );

    const prospectBinds = countLabelsAndBindings(
      brokerageReportData.prospects,
      (item) => _.get(item, "answers.operations.list[0].name.en"),
      (item) => item.isbinded
    );

    setBindChart(prospectBinds);
  }, [brokerageReportData]);

  useEffect(() => {
    if (brokerageReportData.transactions)
      var temp = brokerageReportData.transactions.filter(
        (item) => item.tostatus === "Bind Request"
      );
  }, [brokerageReportData]);

  function joinData(list1, list2, objectName, field1 = "_id", field2 = "_id") {
    return _.map(list1, (item1) => {
      const item1Matches = _.filter(list2, { [field2]: item1[field1] });

      return {
        ...item1,
        [objectName]: item1Matches,
      };
    });
  }

  useEffect(() => {
    const groupKeyGetterProspects = (item) =>
      _.get(item, "answers.operations.list[0].vertical.name.en");

    if (brokerageReportData.prospects) {
      const filterConfigurations = [
        {
          data: brokerageReportData.prospects,
          matchingItem: startDate,
          path: "transactions[0].usertime",
          type: "date",
          startDate: startDate,
          endDate: endDate,
        },
        {
          matchingItem: selectedStatus,
          path: "status",
        },
        {
          matchingItem: selectedBroker,
          path: "broker[0].firstname",
        },
        {
          matchingItem: selectedBusinessSegment,
          path: "answers.operations.list[0].vertical.name.en",
        },
      ];

      const tempFilteredData = filterConfigurations.reduce((data, config) => {
        if (config.type === "date") {
          return filterDataByDateRange(
            data,
            config.startDate,
            config.endDate,
            config.path
          );
        } else {
          return filterData(data, config.matchingItem, config.path);
        }
      }, filterConfigurations[0].data);

      setFilteredData(tempFilteredData);
      setProspectsCharts(
        preparePieChartData(tempFilteredData, groupKeyGetterProspects)
      );
    }
  }, [
    selectedStatus,
    startDate,
    selectedBroker,
    selectedBusinessSegment,
    endDate,
    brokerageReportData,
  ]);

  return (
    <>
      {view === "main" && (
        <Col>
          <Row>
            {cards.map((cardInfo) => {
              return (
                <StatisticCard
                  cardInfo={cardInfo}
                  selectedCard={selectedCard}
                  setSelectedCard={(card) => setSelectedCard(card)}
                />
              );
            })}
          </Row>

          <Row>
            {selectedCard === "dashboard" &&
              !_.isEmpty(brokerageReportData) && (
                <>
                  <Col md={12} className="d-flex justify-content-center">
                    <div>
                      <DatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(update) => {
                          setDateRange(update);
                        }}
                        isClearable={true}
                      />
                    </div>
                    <div>
                      <Select
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "status"
                        )}
                        onChange={(selectedOption) =>
                          setSelectedStatus(selectedOption.value)
                        }
                      />
                    </div>
                    <div>
                      <Select
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "broker[0].firstname"
                        )}
                        onChange={(selectedOption) =>
                          setSelectedBroker(selectedOption.value)
                        }
                      />
                    </div>
                    <div>
                      <Select
                        options={getDropdownItems(
                          brokerageReportData.prospects,
                          "answers.operations.list[0].name.en"
                        )}
                        onChange={(selectedOption) =>
                          setSelectedBusinessSegment(selectedOption.value)
                        }
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <ReportsChart
                      reportData={prospectsCharts}
                      reportChartType="PIE"
                      reportTitle="BUSINESS SEGMENT OVER SELECTED TIME PERIOD"
                    />
                  </Col>
                  <Col md={6}>
                    <ReportsChart
                      reportData={prepareChartData(
                        filteredData,
                        (item) => _.get(item, "status"),
                        "status"
                      )}
                      reportChartType="BAR"
                      reportTitle="CURRENT PROSPECT STATUS"
                    />
                  </Col>
                  <Col md={6}>
                    {/* /binder to vertical */}
                    <ReportsChart
                      reportData={prepareChartData(
                        filteredData,
                        (item) => {
                          const date = new Date(
                            _.get(item, "binders[0].createdAt")
                          );
                          return date.toLocaleDateString();
                        }, // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                        "answers.operations.list[0].vertical.name.en"
                      )}
                      reportChartType="BAR"
                      reportTitle="SALES ANALYSIS BY VERTICAL"
                      isStacked={true}
                    />
                  </Col>

                  <Col md={6}>
                    <ReportsChart
                      reportData={prepareChartData(
                        filteredData,
                        (item) => {
                          const date = new Date(
                            _.get(item, "binders[0].createdAt")
                          );
                          return date.toLocaleDateString();
                        }, // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                        "broker[0].firstname"
                      )}
                      reportChartType="BAR"
                      reportTitle="Sales Analysis By Broker"
                      isStacked={true}
                    />
                  </Col>
                  <Col md={6}>
                    <ReportsChart
                      reportData={prepareChartData(
                        filteredData,
                        (item) => {
                          const date = new Date(
                            _.get(item, "transactions[0].usertime")
                          );
                          return date.toLocaleDateString();
                        },
                        "answers.operations.list[0].vertical.name.en"
                        // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                      )}
                      reportChartType="BAR"
                      reportTitle="prospect added by segment "
                      isStacked={true}
                    />
                  </Col>

                  <Col md={6}>
                    <ReportsChart
                      reportData={prepareChartDataForOneField(
                        filteredData,
                        (item) => {
                          const date = new Date(
                            _.get(item, "transactions[0].usertime")
                          );
                          return date.toLocaleDateString();
                        } // Convert to a string in the format 'MM/DD/YYYY' _.get(item, "binders[0].createdAt")}
                      )}
                      reportChartType="BAR"
                      reportTitle="prospect added"
                      isStacked={true}
                    />
                  </Col>
                </>
              )}
            {selectedCard === "brokerage" &&
              !_.isEmpty(brokerageReportData) && (
                <Col md={12}>
                  <StatisticTable
                    keyField={"_id"}
                    data={brokerageReportData.brokerage}
                    headers={[
                      {
                        text: "Id",
                        dataField: "_id",

                        hidden: true,
                        sort: true,
                      },
                      {
                        text: "Name",
                        dataField: "name",
                        type: "string",
                        filter: textFilter(),
                        sort: true,
                      },
                      {
                        text: "Next Renew Date",
                        dataField: "next_renew_date",
                        type: "date",
                      },
                      {
                        text: "Active Brokers",
                        dataField: "active_brokers.length",
                        type: "array",
                        filter: numberFilter(),
                        sort: true,
                      },
                      {
                        text: "Prospects",
                        dataField: "prospects.length",
                        type: "array",
                        filter: numberFilter(),
                        sort: true,
                      },
                      {
                        text: "Binds",
                        dataField: "prospects",
                        filter: numberFilter(),
                        sort: true,
                        formatter: (cellContent, row) => {
                          return _.filter(
                            row.prospects,
                            (prospect) => prospect.isbinded === true
                          ).length;
                        },
                      },
                    ]}
                    itemsPerPage={5}
                    handleRowClick={(data) => handleClick(data)}
                    view={"brokerage"}
                  />
                </Col>
              )}
            {/* <Col md={12}>
              <StatisticTable
                data={brokeragesList}
                headers={headers}
                itemsPerPage={5}
                handleRowClick={(data) => handleClick(data)}
              />
            </Col> */}
            {selectedCard === "brokers" && !_.isEmpty(brokerageReportData) && (
              <Col md={12}>
                <StatisticTable
                  keyField={"user._id"}
                  data={brokerageReportData.brokers}
                  headers={[
                    {
                      text: "Id",
                      dataField: "user._id",

                      hidden: true,
                      sort: true,
                    },
                    {
                      text: "First Name",
                      dataField: "firstname",
                      type: "string",
                      sort: true,
                    },
                    {
                      text: "Role",
                      dataField: "jobrole",
                      type: "text",
                      sort: true,
                    },
                    {
                      text: "Location",
                      dataField: "location",
                      type: "string",
                      sort: true,
                    },
                  ]}
                  itemsPerPage={5}
                  // handleRowClick={(data) => props.brokerageRowClick(data)}
                />
              </Col>
            )}

            {selectedCard === "transactions" && chartData && (
              <>
                {/* <Col md={12}>
                  <ReportsChart reportData={chartData} reportChartType="BAR" />
                </Col> */}
                <Col>
                  <StatisticTable
                    keyField={"name"}
                    data={prepareInsurerCounts(
                      brokerageReportData.transactions.filter(
                        (item) => item.tostatus === "Quote received"
                      ),
                      [
                        "SBBIPRetail",
                        "CommonwellCommercialGold",
                        "SBContractorsBasic",
                        "Halwell",
                        "APRILContractors",
                        "PeaceHillsContractor",
                        "CommonwellCommercial",
                        "HTMContractors",
                        "SBContractorsDeluxe",
                        "Totten",
                      ]
                    )}
                    headers={[
                      {
                        text: "Name",
                        dataField: "name",
                        type: "string",
                        filter: textFilter(),
                        sort: true,
                      },
                      {
                        text: "Quotes",
                        dataField: "amount",
                        type: "number",
                        sort: true,
                      },
                    ]}
                    itemsPerPage={5}
                    view={"brokerage"}
                  />
                </Col>
                <Col md={12}>
                  <ReportsChart
                    reportData={prepareInsurerCountsForChart(
                      brokerageReportData.transactions.filter(
                        (item) => item.tostatus === "Quote received"
                      ),
                      [
                        "SBBIPRetail",
                        "CommonwellCommercialGold",
                        "SBContractorsBasic",
                        "Halwell",
                        "APRILContractors",
                        "PeaceHillsContractor",
                        "CommonwellCommercial",
                        "HTMContractors",
                        "SBContractorsDeluxe",
                      ]
                    )}
                    reportChartType="BAR"
                  />
                </Col>
              </>
            )}

            {selectedCard === "prospects" &&
              !_.isEmpty(brokerageReportData) && (
                <>
                  <Col md={12} className="d-flex justify-content-center">
                    <ReportsChart
                      reportData={prospectsCharts}
                      reportChartType="PIE"
                      reportTitle="Prospects Breakdown"
                    />
                  </Col>
                  <Col md={12} style={{ marginTop: "24px" }}>
                    <h2>Current Verticals</h2>
                    <StatisticTable
                      keyField={"_id"}
                      data={brokerageReportData.prospects}
                      headers={[
                        {
                          text: "ID",
                          dataField: "_id",
                          type: "string",
                          hidden: true,
                        },
                        // {
                        //   text: "Vertical",
                        //   dataField: "answers.operations.list[0].name.en",
                        //   type: "string",
                        //   filter: textFilter(),
                        // },
                        {
                          text: "Vertical",
                          dataField: "answers.operations.list[0].name.en",
                          type: "string",
                          //   formatter: (cell) => {
                          //     return (
                          //       bindChart.filter((opt) => opt === cell)[0]
                          //         .vertical || ""
                          //     );
                          //   },
                          filter: selectFilter({
                            options: () =>
                              bindChart.map((data) => {
                                return {
                                  value: data.vertical,
                                  label: data.vertical,
                                };
                              }),
                          }),
                        },
                        {
                          text: "Binded",
                          dataField: "isbinded",
                          type: "boolean",
                          formatter: (cellContent, row) => {
                            return row.isbinded ? "Yes" : "No";
                          },
                        },

                        {
                          type: "string",
                          dataField: "status",
                          text: "Status",
                        },
                        // {
                        //   text: "Product Code",
                        //   dataField: "answers.productcode",
                        //   type: "string",
                        // },
                        {
                          text: "Transactions",
                          dataField: "transactions.length",
                          type: "array",
                          filter: numberFilter(),
                        },
                        {
                          text: "Broker",
                          dataField: "broker[0].firstname",
                          type: "string",
                          filter: textFilter(),
                        },
                      ]}
                      itemsPerPage={5}
                      handleRowClick={(data) => {
                        setProspectModal(true);
                        handleClick(data);
                      }}
                    />
                  </Col>
                  <Col md={12} style={{ marginTop: "24px" }}>
                    <h2>All Verticals</h2>
                    <StatisticTable
                      keyField={"label"}
                      data={bindChart}
                      headers={[
                        {
                          text: "Vertical",
                          dataField: "vertical",
                          type: "string",
                          formatter: (cell) => {
                            return (
                              bindChart.filter(
                                (opt) => opt.vertical === cell
                              )[0].vertical || ""
                            );
                          },
                          filter: selectFilter({
                            options: () =>
                              bindChart.map((data) => {
                                return {
                                  value: data.vertical,
                                  label: data.vertical,
                                };
                              }),
                          }),
                        },
                        {
                          text: "Vertical Count",
                          dataField: "count",
                          type: "number",
                          filter: numberFilter(),
                        },

                        {
                          text: "Binds",

                          dataField: "bindCount",
                          type: "string",
                          filter: numberFilter(),
                        },
                      ]}
                      itemsPerPage={5}
                      handleRowClick={(data) => {
                        setProspectModal(true);
                        handleClick(data);
                      }}
                    />
                  </Col>
                  {/* <Col md={12} className="d-flex justify-content-center">
                    <ReportsChart
                      reportData={prospectsCharts}
                      reportChartType="PIE"
                      reportTitle="Prospects Breakdown"
                    />
                  </Col> */}
                </>
              )}
            {selectedCard === "binders" && !_.isEmpty(brokerageReportData) && (
              <>
                <Col md={12}>
                  <StatisticTable
                    keyField={"_id"}
                    data={brokerageReportData.binders}
                    headers={[
                      {
                        text: "ID",
                        dataField: "_id",
                        type: "string",
                        hidden: true,
                      },
                      {
                        text: "Insurer",
                        dataField: "insurer",
                        type: "string",
                        sort: true,
                      },
                      {
                        text: "Created At",
                        dataField: "createdAt",
                        type: "date",
                        sort: true,
                        formatter: (cell, row) => {
                          return moment(cell).format("llll");
                        },
                      },
                    ]}
                    itemsPerPage={5}
                    //   handleRowClick={(data) => {
                    //     setProspectModal(true);
                    //     handleClick(data);
                    //   }}
                  />
                </Col>
                {/* <Col md={12}>
                    <StatisticTable
                      keyField={"label"}
                      data={bindChart}
                      headers={[
                        {
                          text: "Vertical",
                          dataField: "vertical",
                          type: "string",
                          formatter: (cell) => {
                            return (
                              bindChart.filter(
                                (opt) => opt.vertical === cell
                              )[0].vertical || ""
                            );
                          },
                          filter: selectFilter({
                            options: () =>
                              bindChart.map((data) => {
                                return {
                                  value: data.vertical,
                                  label: data.vertical,
                                };
                              }),
                          }),
                        },
                        {
                          text: "Vertical Count",
                          dataField: "count",
                          type: "number",
                          filter: numberFilter(),
                        },

                        {
                          text: "Binds",

                          dataField: "bindCount",
                          type: "string",
                          filter: numberFilter(),
                        },
                      ]}
                      itemsPerPage={5}
                      handleRowClick={(data) => {
                        setProspectModal(true);
                        handleClick(data);
                      }}
                    />
                  </Col>
                  <Col md={12}>
                    <ReportsChart
                      reportData={prospectsCharts}
                      reportChartType="PIE"
                      reportTitle="Prospects Breakdown"
                    />
                  </Col> */}
                <Col md={12} className="d-flex justify-content-center">
                  <hr />
                </Col>

                <Col md={12} className="d-flex justify-content-center">
                  <ReportsChart
                    reportData={prepareChartData(
                      brokerageReportData.prospects,
                      function groupKeysOnDate(item) {
                        return new Date(item.createdAt).toLocaleDateString();
                      },
                      "insurer"
                    )}
                    reportChartType="BAR"
                  />
                </Col>
                <Col md={12} className="d-flex justify-content-center">
                  <div>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={true}
                    />
                  </div>
                </Col>
              </>
            )}
          </Row>
        </Col>
      )}
      {view === "brokerage" && (
        <BrokerageView
          brokerage={selectedItem}
          navigateBack={() => changeView("main")}
        />
      )}
      {selectedItem?.transactions && (
        <Modal
          size="lg"
          show={prospectModal}
          onHide={() => setProspectModal(!prospectModal)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Transaction Log</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedItem.transactions.map((transaction) => {
              return (
                <>
                  <p> from: {transaction.fromstatus} </p>
                  <p> to: {transaction.tostatus}</p>
                  <hr />
                </>
              );
            })}
          </Modal.Body>
          {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
        </Modal>
      )}
    </>
  );
};

export default AdminView;
